import clsx from 'clsx'
import React from 'react'

export const Description = ({ data }: { data: any }) => {
  return (
    <>
      <p
        className={clsx(' mt-3 text-center ', {
          'font-medium opacity-60': !data.bold,
          'font-semibold': data.bold,
          'text-[14px]': data.isSmall,
        })}
        dangerouslySetInnerHTML={{ __html: data.description }}
      ></p>
    </>
  )
}
